export function getProperty(crmObject, propertyName) {
  const foundProperty = crmObject.properties.find(({
    name
  }) => name === propertyName);
  return foundProperty ? foundProperty.value : '';
}